import { t } from 'i18next';

import { SwitchCell } from 'core/elements';

import { AdjustedQuantityCell, AssignUomCell, PartNumberCell, UomStatusCell } from './cells';

export const getColumnDefs = () => [
  {
    colId: 'part',
    headerName: t('headerPartNumber'),
    field: 'number',
    cellRenderer: PartNumberCell,
    filter: 'agTextColumnFilter',
    floatingFilter: true,
    minWidth: 220,
  },
  {
    colId: 'manufacturer',
    headerName: t('headerManufacturer'),
    field: 'manufacturer',
    filter: 'agTextColumnFilter',
    floatingFilter: true,
    enableRowGroup: true,
    minWidth: 180,
  },
  {
    colId: 'uom',
    headerName: t('headerUom'),
    field: 'uom',
    sortable: false,
    cellRenderer: UomStatusCell,
    filter: 'agTextColumnFilter',
    floatingFilter: true,
    enableRowGroup: true,
    minWidth: 180,
  },
  {
    colId: 'assignedUom',
    headerName: t('changeUomTo'),
    field: 'assignedUom',
    sortable: false,
    cellRenderer: AssignUomCell,
    minWidth: 220,
  },
  {
    colId: 'adjustedQuantity',
    headerName: t('headerTotalQuantity'),
    field: 'adjustedQuantity',
    sortable: false,
    cellRenderer: AdjustedQuantityCell,
    minWidth: 140,
    maxWidth: 160,
  },
  {
    colId: 'omit',
    headerName: t('headerOmit'),
    field: 'omit',
    sortable: false,
    minWidth: 100,
    width: 100,
    maxWidth: 100,
    cellRenderer: SwitchCell,
    cellRendererParams: {
      colId: 'omit',
    },
  },
];
